var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Alert组件
 * @author (zhangwenting)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { classPrefix } from '../../common/util';

import './Alert.less';

/**
 * 参数说明
 *
 * message：       必需，  一级信息，string 任意字符串
 * onCancel：      必需，  事件回调，切换当前组件显示状态，func
 * isShow：        必需，  组件显示与否，bool
 * type:           非必需，alert类型，可选值 【info | warning | error | success】，默认值info
 * closable：      非必需，是否可关闭，bool 【true | false】，默认值 true
 * isStress：      非必需，一级信息是否加粗显示，bool 【true | false】，默认值 true
 * description：   非必需，二级信息，string 任意字符串
 *
 */

var Alert = function (_Component) {
    _inherits(Alert, _Component);

    function Alert(props) {
        _classCallCheck(this, Alert);

        return _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));
    }

    _createClass(Alert, [{
        key: 'onCancel',
        value: function onCancel() {
            this.props.onCancel();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props = this.props,
                type = _props.type,
                isStress = _props.isStress,
                classPrefix = _props.classPrefix;

            var containerClassName = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-alert', true), _defineProperty(_classnames, classPrefix + '-alert-' + type, true), _classnames));
            var infoClassName = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-alert-information', true), _defineProperty(_classnames2, classPrefix + '-alert-bold', isStress), _classnames2));
            var closableClassName = classnames(_defineProperty({}, classPrefix + '-alert-delete', true));
            var descriptionClassName = classnames(_defineProperty({}, classPrefix + '-alert-subInformation', true));
            return React.createElement(
                'div',
                null,
                this.props.isShow ? React.createElement(
                    'div',
                    { className: containerClassName },
                    React.createElement(
                        'div',
                        { className: infoClassName },
                        this.props.closable ? React.createElement('span', { className: closableClassName, onClick: this.onCancel.bind(this) }) : null,
                        React.createElement(
                            'span',
                            { className: 'msg' },
                            this.props.message
                        )
                    ),
                    this.props.description ? React.createElement(
                        'div',
                        { className: descriptionClassName },
                        this.props.description
                    ) : null
                ) : null
            );
        }
    }]);

    return Alert;
}(Component);

export default Alert;


Alert.defaultProps = {
    type: 'info',
    closable: true,
    isStress: true,
    message: '',
    description: '',
    classPrefix: classPrefix
};

Alert.propTypes = {
    isShow: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['info', 'warning', 'error', 'success']),
    closable: PropTypes.bool,
    isStress: PropTypes.bool,
    message: PropTypes.string.isRequired,
    description: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    classPrefix: PropTypes.string
};